import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { axiosProvider } from '@/store/provider';
import { refreshTokenInterceptorProvider } from '@/store/provider/intercept';

export interface AuthUserResponse {
  status: string;
  message: string;
  user: {
    userStatus: string;
    enabled: boolean;
  };
}

export class AuthUserService {
  private request: AxiosInstance;

  constructor() {
    this.request = axiosProvider('auth', {}, {
      response: [refreshTokenInterceptorProvider()]
    });
  }

  async getUserInfo(cognitoEmail: string, config: AxiosRequestConfig = {}) {
    return this.request.get<AuthUserResponse>(`user/${cognitoEmail}`, config);
  }
}

const authUserService = new AuthUserService();
export { authUserService };
